import apiClient from './api';
import { getApiAccessToken } from './MapComponentsService';

export interface StartSigningRequest {
    objectId: number;
    contractId: number;
    currentUserId: number;
    primarySigner: string;
    primaryEmail: string;
    secondarySigner: string;
    secondaryEmail: string;
    infoEmails?: string[];
    pdfBase64: string;
}

export interface SigningStatusDto {
    id: number;
    objectId: number;
    requestId: string;
    created: string;
    status: string;
    statusCode: number;
    hasSignedFiles: boolean;
    signedFileName?: string;
    primarySigner: string;
    secondarySigner: string;
    lastStatusUpdate?: string;
    releaseTimestamp?: string;
    releaseComment?: string;
}

export interface StartSigningResponse {
    id: number;
    requestId: string;
    status: string;
    message: string;
}

export const startSigning = async (request: StartSigningRequest): Promise<StartSigningResponse> => {
    const token = await getApiAccessToken();
   // console.log('Auth token for signing:', token ? 'Token received' : 'NO TOKEN');
    if (token) {
       // console.log('Token length:', token.length);
        // console.log('Token preview:', token.substring(0, 50) + '...');
    }
    const response = await apiClient.post<StartSigningResponse>(`/api/CityObjectSigning/start`, request, {
        headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
};

export const getSigningStatus = async (id: number): Promise<SigningStatusDto> => {
    const token = await getApiAccessToken();
    const response = await apiClient.get<SigningStatusDto>(`/api/CityObjectSigning/status/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
};

export const getSigningHistory = async (objectId: number): Promise<SigningStatusDto[]> => {
    const token = await getApiAccessToken();
    const response = await apiClient.get<SigningStatusDto[]>(`/api/CityObjectSigning/history/${objectId}`, {
        headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
};

export const downloadSignedFile = async (id: number): Promise<{ message: string; fileName: string; filePath: string }> => {
    const token = await getApiAccessToken();
    const response = await apiClient.post<{ message: string; fileName: string; filePath: string }>(`/api/CityObjectSigning/download-signed/${id}`, {}, {
        headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
};

export const downloadSignedFileForUser = async (id: number): Promise<Blob> => {
    const token = await getApiAccessToken();
    const response = await apiClient.get(`/api/CityObjectSigning/download/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
        responseType: 'blob'
    });
    return response.data as Blob;
};

export const releaseSigning = async (id: number, comment?: string): Promise<{ message: string }> => {
    const token = await getApiAccessToken();
    const response = await apiClient.post<{ message: string }>(`/api/CityObjectSigning/release/${id}`, comment, {
        headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
};

export const releaseSigningByObjectId = async (objectId: number, comment: string): Promise<{ message: string }> => {
    const token = await getApiAccessToken();
    const response = await apiClient.post<{ message: string }>(
        `/api/CityObjectSigning/release-object/${objectId}`,
        { comment },
        { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
};
